export default function (_ref) {
  var numberLocale = _ref.numberLocale;

  return {
    formatNumber: function formatNumber(number, render) {
      return Number(render(number)).toLocaleString(numberLocale);
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/instantsearch.js/es/lib/createHelpers.js
// module id = null
// module chunks = 